import { useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'validate.js';

import { pushParams, resetParams } from 'dpl/actions/query_params';
import {
  FILTER_DISTANCE_IN_MILES,
  FILTER_LATITUDE,
  FILTER_LOCATION_NAME,
  FILTER_LONGITUDE,
  FILTER_POSTAL_CODE,
  FILTERS_MODAL,
  PAGE,
  RESULTS_TYPE
} from 'dpl/constants/query_params';
import {
  FILTER_PARAMS,
  RESULTS_TYPES
} from 'dpl/puppy_search_results/utils/constants';
import { pick } from 'dpl/shared/utils';

const DEFAULT_RESULTS_TYPE = window.__DPL_BOT_UA
  ? RESULTS_TYPES.BREEDERS
  : RESULTS_TYPES.PUPPIES;

const BREEDER_RESULTS_FILTERS = [
  FILTER_LATITUDE,
  FILTER_LONGITUDE,
  FILTER_LOCATION_NAME,
  FILTER_DISTANCE_IN_MILES,
  FILTER_POSTAL_CODE
];

export default function useSearchFiltering() {
  const dispatch = useDispatch();
  const params = useSelector(({ queryParams }) => queryParams);

  const isNewMobileLayoutEnabled = useSelector(
    ({ server }) => server.isNewMobileLayoutEnabled
  );

  const filters = useMemo(() => pick(params, FILTER_PARAMS), [params]);

  const breederResultsFilters = useMemo(
    () => pick(params, BREEDER_RESULTS_FILTERS),
    [params]
  );

  const isFiltersModalOpen = params[FILTERS_MODAL] === 'true';
  const hasFilters = !isEmpty(filters);

  const resultsType = useMemo(() => {
    if (!isNewMobileLayoutEnabled) {
      return params[RESULTS_TYPE] || DEFAULT_RESULTS_TYPE;
    }

    if (shallowEqual(filters, breederResultsFilters)) {
      return RESULTS_TYPES.BREEDERS;
    }

    return RESULTS_TYPES.PUPPIES;
  }, [params]);

  function toggleFilters() {
    dispatch(
      pushParams({ [FILTERS_MODAL]: !isFiltersModalOpen }, { hash: true })
    );
  }

  function clearFilters() {
    const filterNames = [
      PAGE,
      ...FILTER_PARAMS,
      isNewMobileLayoutEnabled && RESULTS_TYPE
    ].filter(Boolean);

    dispatch(resetParams(...filterNames, { hash: true }));
  }

  return {
    clearFilters,
    hasFilters,
    isFiltersModalOpen,
    resultsType,
    toggleFilters
  };
}
